<template>
    <li class="feed-item" :data-mpid="feed.id" :data-pulltime="feed.pull_time" ref="item">
        <a v-if="feed.showType === 1" class="plainText" :href="feed.link" :data-log-content-ev="feed.stat_flag" @click.prevent="clickItemHandler(feed)" ref="link">
            <h3 class="title" v-html="feed.title"></h3>
            <footer class="item_info">
                <div class="name">{{feed.author}}</div>
                <div class="time" v-show="feed.fix_c_time">{{feed.fix_c_time}}</div>
                <div class="cmt" v-show="Number(feed.read_num) !== 0"><em class="cmt_name">{{feed.read_num}}</em>阅</div>
            </footer>
        </a>
        <a v-if="feed.showType === 2" class="onePic" :href="feed.link" :data-log-content-ev="feed.stat_flag" @click.prevent="clickItemHandler(feed)">
            <div class="onePic_detail">
                <h3 class="title" v-html="feed.title"></h3>
                <div class="item_info">
                    <div v-if="feed.type === 64 || feed.type === 65 || feed.type == 182 || feed.type == 185" class="qianfan icon-live"></div>
                    <div class="name">{{feed.author}}</div>
                    <div class="time" v-show="feed.fix_c_time">{{feed.fix_c_time}}</div>
                    <div class="cmt" v-show="Number(feed.read_num) !== 0"><em class="cmt_name">{{feed.read_num}}</em>阅</div>
                </div>
            </div>
            <div class="onePic_img" v-lazy:background-image="mini_picUrl(feed.picUrl)">
                <div v-if="feed.type === 64 || feed.type === 65 || feed.type == 182 || feed.type == 185 || feed.type ==4 || feed.type == 5" class="video-icon"></div>
            </div>
        </a>
        <a v-if="feed.showType === 3" class="threePic" :href="feed.link" :data-log-content-ev="feed.stat_flag" @click.prevent="clickItemHandler(feed)">
            <h3 class="title" v-html="feed.title"></h3>
            <ul class="list_img clearfix">
                <template v-for="item in feed.images">
                    <li :key="item" class="img_wrap" v-lazy:background-image="mini_picUrl(item)"></li>
                </template>
            </ul>
            <footer class="item_info">
                <div class="name">{{feed.author}}</div>
                <div class="time" v-show="feed.fix_c_time">{{feed.fix_c_time}}</div>
                <div class="cmt" v-show="Number(feed.read_num) !== 0"><em class="cmt_name">{{feed.read_num}}</em>阅</div>
            </footer>
        </a>
    </li>
</template>
<script>
import bus from '../_utils/event-bus';
import nativeUtil from '../_utils/native-util.js'
import Util from '../_utils/util.js'
export default {
    props: {
        feed: {},
        pulltime: {
            default: 1
        }
    },
    methods: {
        clickItemHandler(data) {
            const url = this.$refs.item.querySelector('a').getAttribute('href')
            nativeUtil.openContent(url, data)
        },
        mini_picUrl: Util.mini_picUrl
    },
    components: {
        
    }
}
</script>
<style lang="less" rel="stylesheet/less">
.feed-item {
    position: relative;
    padding-top: 12px;
    padding-bottom: 12px;
    border-bottom: 1px solid #f5f5f5;/*no*/
    // 纯文本
    .plainText {
        .title{
            margin-bottom: 7.5px;/*使用margin为了防止overflow 裁掉一半文字*/
            font-size: 18px;/*no*/
            line-height: 1.3em;
            -webkit-line-clamp: 2;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            display: box;
            -webkit-box-orient: vertical;
            color: #212121;
        }
        .item_info {
            padding-top: 2px;
            color: #999;
            font-size: 12px;
            overflow: hidden;
            .name {
                float: left;
                max-width: 10em;
                line-height: 1.05em;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }
            .time {
                float: left;
                position: relative;
                line-height: 1.05em;
                padding-left: 15px;
                &:before{
                    content: '·';
                    position: absolute;
                    left: 0;
                    top: 0;
                    width: 15px;
                    text-align: center;
                }
            }
            .cmt {
                float: right;
                color: #212121;
                .cmt_name{
                    float: left;
                    margin-right: 4px;
                }
            }
        }
    } 
    // 单图
    .onePic {
        display: flex;
        .onePic_detail{
            position: relative;
            flex: 1;
            .title {
                margin-right: 10px;
                font-size: 18px;/*no*/
                line-height: 1.3em;
                -webkit-line-clamp: 2;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                display: box;
                -webkit-box-orient: vertical;
                color: #212121;
            }
            .item_info {
                color: #999;
                overflow: hidden;
                color: #999;
                font-size: 12px;
                position: absolute;
                bottom: 0;
                width: 100%;
                box-sizing: border-box;
                padding-right: 22px;
                .qianfan{
                    float: left;
                    font-size: 12px;
                    line-height: 1.05em;
                    margin-right: 4px;
                }
                .name {
                    float: left;
                    max-width: 6em;
                    line-height: 1.2em;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                }
                .time {
                    float: left;
                    position: relative;
                    line-height: 1.05em;
                    padding-left: 15px;
                    &:before{
                        content: '·';
                        position: absolute;
                        left: 0;
                        top: 0;
                        width: 15px;
                        text-align: center;
                    }
                }
                .cmt {
                    float: right;
                    color: #212121;
                    .cmt_name{
                        float: left;
                        margin-right: 4px;
                    }
                }
            }
        }
        .onePic_img{
            position: relative;
            flex-shrink: 0;
            width: 32.75346%;
            padding-top: 21.55%;
            background-size: cover;
            background-image: url('../assets/images/preload.png');
            .video-icon{
                position: absolute;
                left: 0;right: 0;top: 0;bottom: 0;
                width: 32px;
                height: 32px;
                margin: auto;
                background: url('../assets/images/ic_play_b.png') no-repeat center center;
                background-size: contain;
            }
        }
        
    }
    // 三图
    .threePic {
        .title{
            margin-bottom: 7.5px;/*使用 margin 为了防止overflow 裁掉一半文字*/
            font-size: 18px;/*no*/
            line-height: 1.3em;
            -webkit-line-clamp: 2;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            display: box;
            -webkit-box-orient: vertical;
            color: #212121;
        }
        .list_img{
            .img_wrap{
                float: left;
                width: 32.75346%;
                padding-top: 21.55%;
                overflow: hidden;
                background-size: cover;
                background-image: url('../assets/images/preload.png');
                &:first-child{
                    margin-right: 0.8698%;
                }
                &:last-child{
                    margin-left: 0.8698%;
                }
            }
        }
        .item_info {
            padding-top: 10px;
            color: #999;
            font-size: 12px;
            overflow: hidden;
            .name {
                float: left;
                max-width: 10em;
                line-height: 1.05em;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }
            .time {
                float: left;
                line-height: 1.05em;
                position: relative;
                padding-left: 15px;
                &:before{
                    content: '·';
                    position: absolute;
                    left: 0;
                    top: 0;
                    width: 15px;
                    text-align: center;
                }
            }
            .cmt {
                float: right;
                color: #212121;
                .cmt_name{
                    float: left;
                    margin-right: 4px;
                }
            }
        }
    }
}

//加载中
@keyframes fadeOut {
    0% {
        opacity: 0;
    }
    100% {
        opacity: 1;
    }
}
//专门处理安卓下的样式
// .ios{
//     .feed-item{
//         border-bottom: 0.5px solid #e8e8e8;/*no*/
//     }
// }
//     .feed-item .plainText .title {
//         font-size: 16.3px;
//     }
//     .feed-item .onePic .onePic_detail .title {
//         font-size: 16.3px;
//     }
//     .feed-item .threePic .title{
//         font-size: 16.3px;
//     }
// }
</style>


// WEBPACK FOOTER //
// src/components/feed-item.vue